var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-stepper-content',{attrs:{"step":"1"}},[_c('h3',[_vm._v("Paso 1")]),_c('p',[_vm._v("Aquí va el contenido del paso 1.")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.goNext}},[_vm._v("Siguiente")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }